// extracted by mini-css-extract-plugin
export var labelWrapper = "_lz-0";